import { NgModule } from '@angular/core';

import { MgeIconElement } from './MgeIcon.element';

@NgModule({
  declarations: [MgeIconElement],
  exports: [MgeIconElement],
})
export class MgeIconModule {}
